import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedMessage} from "react-intl";

import InfoValueCard from "components/card/InfoValueCard";

import getLastImportReport from "api/importReport/lastImportReport";

function DatabaseIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
             stroke="#3730d4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
             className="lucide lucide-database h-4 w-4 text-primary"
        >
            <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
            <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
            <path d="M3 12A9 3 0 0 0 21 12"></path>
        </svg>
    );
}

HeadInfos.propTypes = {
    feedId: PropTypes.object,
    totalItems: PropTypes.number
};

function HeadInfos({feedId, totalItems}) {
    const [lastImportReport, setLastImportReport] = useState(null);

    useEffect(() => {
        getLastImportReport(feedId).then((res) => setLastImportReport(res))
    }, []);

    if (!lastImportReport) {
        return null;
    }

    return (
        <div style={{display: 'flex', gap: '16px'}}>
            <InfoValueCard
                borderColor={'info'}
                value={totalItems}
                label={<FormattedMessage id='feed.history.list.label.totalImport' />}
                icon={<DatabaseIcon />}
            />
            <InfoValueCard
                borderColor={'success'}
                value={(
                    <FormattedDate
                        value={new Date(lastImportReport.endedAt)}
                        month={"numeric"}
                        day={"numeric"}
                        hour={"numeric"}
                        minute={"numeric"}
                    />
                )}
                label={'Dernier import'}
                icon={<DatabaseIcon />}
            />
            <InfoValueCard
                borderColor={'success'}
                value={lastImportReport.nbErrors}
                label={'Erreurs dernier import'}
                icon={<DatabaseIcon />}
            />
            {/*TODO: fake*/}
            <InfoValueCard
                borderColor={'info'}
                value={'+385 / 120'}
                label={'Réf. ajoutées / modifiées'}
                icon={<DatabaseIcon />}
            />
        </div>
    );
}

export default HeadInfos;
